export default __webpack_public_path__ + "static/media/logo.489f2bd4.svg";